import { useStorage } from '@vueuse/core'
import { useStore } from '~/store'

export const star = '******'

export function useAssetEye() {
  const eye = useStorage('ttx-eye', false)

  function toggle(value) {
    eye.value = value
  }

  const fixByEye = computed(() => (v) => {
    return eye.value ? v : star
  })

  return { eye, fixByEye, toggle }
}

export function useUnit() {
  const store = useStore()
  const unitType = ref('btc')
  const unitList = computed(() => [
    { label: 'BTC', value: 'btc' },
    { label: 'USDT', value: 'usdt' },
  ])
  const unit = computed(() => unitList.value.find(i => i.value === unitType.value) ?? {})
  const dp = computed(() => store.spotCurrenciesRaw[unit.value.label]?.showPrecision ?? 2)

  return { unitList, unitType, dp, unit }
}
